import * as React from 'react';
import styled from '@emotion/styled';
import { useAuthContext } from '../hooks/auth';
import { Button, InstructionsSmall } from './global.styles';
export const HeaderContainer = styled.div `
  display: flex;
  justify-content: space-between;
`;
export const HeaderControls = styled.div `
  display: flex;
  align-items: center;
`;
export const Header = () => {
    const { operatorInfo } = useAuthContext();
    return (React.createElement(HeaderContainer, null,
        React.createElement("h1", null, "Communicate Support Tool"),
        React.createElement(HeaderControls, null,
            React.createElement(InstructionsSmall, null, operatorInfo.email),
            React.createElement(Button, { onClick: () => {
                    window.location.href = '/support-signout.html';
                } }, "Signout"))));
};
//# sourceMappingURL=header.js.map